<template>
  <div class="button print-note">
    <p class="print-caution">
      <template v-if="device !== 'tablet'">
        <span>※印刷時にご確認ください※</span
        >以下、ブラウザの印刷機能の設定をご確認ください。<br />・用紙サイズ：A4（縦横設定がある場合は縦）を選択<br />・余白：カスタムを選択、プレビュー画面で見切れないよう調整ください<br />・オプション：ヘッダーとフッターにチェック<br />・倍率：規定を選択
      </template>
      <template v-else>
        <span>※印刷はパソコンから行えます</span>
        印刷したい場合は、パソコンで管理画面にログインしてください。
      </template>
    </p>
  </div>
</template>

<script>
import { getDevice } from '@/lib/common/index'
const device = getDevice()
export default {
  data() {
    return {
      device: device,
    }
  }
}
</script>


<style lang="scss">
.print-caution {
  font-size: 14px;
  border: solid 1px red;
  margin: 0;
  padding: 8px 10px;
  min-width: 456px;
  display: block;
  span {
    font-size: 14px;
    font-weight: bold;
    color: red;
    text-align: center;
    display: block;
    margin-bottom: 5px;
  }
}
.print-note {
  max-width: calc(1000px + (1.25rem * 2));
  margin: 0 auto 20px;
  display: flex;
  justify-content: flex-end;
}
</style>